<div class="scad-test-flow">
  <div class="scad-test-flow__buttons">
    <div class="scad-flow-btn">
      Test Flow v1.0 <em class="scad-icon scad-icon-close-1"> </em>
    </div>
    <div class="scad-flow-btn scad-flow-btn--active">
      Test Flow v1.0 <em class="scad-icon scad-icon-close-1"> </em>
    </div>
    <div class="scad-flow-btn scad-flow-btn--add">+</div>
  </div>

  <div class="scad-test-flow__buttons">
    <div class="scad-test-flow__action">
      <img src="/assets/images/svg/help.svg" alt="" />
    </div>
    <div class="scad-test-flow__action">
      <img src="/assets/images/svg/save.svg" alt="" />
    </div>

    <button class="scad-drop-btn" [matMenuTriggerFor]="menu">
      <span><img src="/assets/images/svg/recent.svg" alt="" /> </span>
      <span class="arrow"
        ><img src="/assets/images/svg/down-arrow.svg" alt=""
      /></span>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>Item 1</button>
      <button mat-menu-item>Item 2</button>
    </mat-menu>
  </div>
</div>
